import {
  FufillmentOrderItem,
  Fulfillment,
  Medication,
  Prescription,
} from '../../../__generated__/graphql';
import { useQuery } from '@apollo/client';
import { graphql } from '../../../__generated__';
import currency from 'currency.js';
import { useUsersList } from '../../../Common/hooks/useUsersList';
import React, { useState } from 'react';
import { Box, Button, HStack, Image, Popover, Text, VStack } from 'native-base';
import { generateCloudflareImage } from '../../../DoctorMedications/const/cloudflareImage';
import { Icon } from '../../../Common/components/Icon';
import { faSync } from '@fortawesome/pro-solid-svg-icons/faSync';
import { SwapItemModal } from './SwapItemModal';

export type OrderModalAction = {
  name: string;
  enabled: boolean;
  callback: () => void;
};

export const OrderItem = ({
  item,
  script,
  order,
}: {
  item: FufillmentOrderItem;
  script: Prescription;
  order: Fulfillment;
}) => {
  const { data } = useQuery(
    graphql(`
      query orderItemMedication($ID: ID) {
        medication(id: $ID) {
          name
          id
          retail
          image
          cost
          __typename
        }
      }
    `),
    {
      fetchPolicy: 'cache-first',
      variables: {
        ID: item.ID,
      },
    },
  );

  const medication = data?.medication as Medication;

  const totalCost = currency(data?.medication?.retail ?? 0).multiply(item?.QTY ?? 0);

  const { findUser } = useUsersList();

  const [swapModalOpen, setSwapModalOpen] = useState(false);

  return (
    <HStack space={6}>
      <Box w={10} h={10}>
        <Image
          resizeMode={'contain'}
          source={{ uri: generateCloudflareImage(data?.medication?.image) }}
          w={10}
          h={10}
        />
      </Box>

      <VStack flex={1}>
        <Text fontWeight={600}>
          {item.QTY} x {data?.medication?.name}
        </Text>

        <HStack>
          <Text flex={1}>Doctor:</Text>
          <Text flex={2}>{findUser(script?.doctor)?.name}</Text>
        </HStack>

        <HStack>
          <Text flex={1}>Token:</Text>
          <Text flex={2}>{script?.erxToken ?? 'eRX Token'}</Text>
        </HStack>
      </VStack>

      <VStack space={2}>
        <Text>{totalCost.format()}</Text>

        <Popover
          placement={'top'}
          isOpen={swapModalOpen}
          onOpen={() => setSwapModalOpen(true)}
          onClose={() => setSwapModalOpen(false)}
          trigger={(triggerProps) => {
            return (
              <Button
                opacity={order?.cancelled || order.dispensed ? 0.5 : 1}
                disabled={order?.cancelled || order.dispensed}
                {...triggerProps}
                variant={'outline'}
                size={'sm'}
              >
                <Icon icon={faSync} size={'sm'} />
              </Button>
            );
          }}
        >
          {swapModalOpen && (
            <SwapItemModal
              medication={medication}
              order={order}
              item={item}
              close={() => setSwapModalOpen(false)}
            />
          )}
        </Popover>
      </VStack>
    </HStack>
  );
};
